import React from "react";

import { useMMM } from "../mmm-provider";

export const useLoadBudgetMixes = () => {
  const { isBudgetMixDataLoading, loadBudgetMixData } = useMMM();
  return {
    isBudgetMixDataLoading,

    loadBudgetMixData,
  };
};
